import { $ } from './../helpers/query';

export default () => {
}
